import React from 'react';

interface MaterialIconProps {
  name: string;
  size?: number;
  fill?: boolean;
  weight?: number;
  className?: string;
  style?: React.CSSProperties;
}

// Calca MaterialIcon de mobile-frame.jsx (Claude Design) — íconos vía Material Symbols Outlined.
export const MaterialIcon: React.FC<MaterialIconProps> = ({ name, size = 24, fill = false, weight = 400, className = '', style }) => (
  <span
    className={`material-symbols-outlined ${className}`}
    style={{
      fontSize: size,
      fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`,
      lineHeight: 1,
      ...style,
    }}
  >
    {name}
  </span>
);
